import { z } from "zod";
/** Типы действий пользователя */
export const ActivityTypeEnum = z.enum([
    "file_upload",
    "file_delete",
    "work_order_check",
    "synonym_add",
    "synonym_delete",
    "auth_login",
    "auth_login_failed",
    "auth_logout",
    "auth_account_locked",
    "auth_password_change",
    "auth_password_reset",
    "auth_user_create",
    "auth_user_update",
    "reconciliation_set_created",
    "reconciliation_set_updated",
    "reconciliation_set_deleted",
    "reconciliation_run",
    "pdf_export",
]);
/** Статусы результата действия */
export const ActivityStatusEnum = z.enum(["in_progress", "success", "error", "warning"]);
/** Уровни технологических сообщений */
export const DetailLevelEnum = z.enum(["error", "warning", "info", "debug"]);
/** Действие пользователя в ответе API */
export const ActivitySchema = z.object({
    id: z.number(),
    activityType: ActivityTypeEnum,
    description: z.string(),
    status: ActivityStatusEnum,
    entityType: z.string().nullable(),
    entityId: z.number().nullable(),
    startedAt: z.string(),
    finishedAt: z.string().nullable(),
    durationMs: z.number().nullable(),
    detailCount: z.number(),
    createdAt: z.string(),
});
/** Технологическое сообщение (уровень 2) */
export const ActivityDetailSchema = z.object({
    id: z.number(),
    level: DetailLevelEnum,
    message: z.string(),
    metadata: z.record(z.unknown()).nullable(),
    createdAt: z.string(),
});
/** Query-параметры GET /api/activities */
export const GetActivitiesQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    type: z.string().optional(),
    status: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    sort: z.enum(["asc", "desc"]).default("desc"),
});
/** Ответ GET /api/activities */
export const GetActivitiesResponseSchema = z.object({
    activities: z.array(ActivitySchema),
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
    total: z.number(),
});
/** Query-параметры GET /api/activities/:id/details */
export const GetActivityDetailsQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(20),
    offset: z.coerce.number().int().min(0).default(0),
});
/** Ответ GET /api/activities/:id/details */
export const GetActivityDetailsResponseSchema = z.object({
    details: z.array(ActivityDetailSchema),
    total: z.number(),
    hasMore: z.boolean(),
});
/** Query-параметры GET /api/activities/summary */
export const ActivitySummaryQuerySchema = z.object({
    groupBy: z.enum(["type", "status"]),
    type: z.string().optional(),
    status: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
});
/** Ответ GET /api/activities/summary */
export const ActivitySummaryResponseSchema = z.object({
    groups: z.array(z.object({
        key: z.string(),
        label: z.string(),
        count: z.number(),
    })),
    total: z.number(),
});
//# sourceMappingURL=activities.js.map